import { SubscriptionCancelSurvey2ndForm } from "./subscription-cancel-survey-2nd.types";

export const initialValues: SubscriptionCancelSurvey2ndForm = {
  whatGood: "",
  howToPrevent: "",
  wantInterview: "",
};
